/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import n from "prop-types";
const r = class r extends t.Component {
  /**
   * @hidden
   */
  render() {
    return null;
  }
};
r.propTypes = {
  text: n.string,
  url: n.string,
  icon: n.string,
  disabled: n.bool,
  cssClass: n.string,
  cssStyle: n.object,
  render: n.any,
  linkRender: n.any,
  contentRender: n.any,
  data: n.any
};
let s = r;
export {
  s as MenuItem
};
